import { Box, Grid, Typography } from '@mui/material';
import LiveClock from 'components/LiveClock/LiveClock.js';
import PropTypes from 'prop-types';
import { brandColors } from 'types/colors';

import MDBox from '../../components/MDBox/index';
import MiniStatisticsCard from '../SensorsListPage/components/MiniStatisticsCard/index';

const MDBoxCss = {
  borderRadius: '.8rem',
  minWidth: 'fit-content',
  marginBottom: '.3rem',
  marginRight: {
    xs: '1rem',
    lg: '0',
  },
};

// MiniStatisticsCard supports one label and one value. BDI needs three colored values,
// so this small local component keeps the Thermal and Air layouts the same.
const BdiSummaryCard = ({ title, justified, saveable, requested }) => {
  const formatValue = value => (typeof value === 'number' ? `${value}%` : 'N/A');
  const labelStyle = { fontSize: '.9rem', fontWeight: 600 };
  const valueStyle = { fontSize: '.9rem', fontWeight: 600 };

  return (
    <MDBox sx={{ display: 'flex', gap: '.7rem', height: '2.5rem', marginBottom: '.3rem' }}>
      <MDBox
        sx={{
          alignItems: 'center',
          backgroundColor: brandColors.GREY_LIGHT,
          borderRadius: '.4rem',
          display: 'flex',
          padding: '.4rem 0 .4rem 1.3rem',
          width: '10.5rem',
        }}>
        <Typography sx={labelStyle}>
          <Box component="span" sx={{ color: brandColors.BLACK }}>
            {title}{' '}
          </Box>
          <Box component="span" sx={{ color: brandColors.BLUE, fontWeight: 800 }}>
            J
          </Box>
          <Box component="span" sx={{ color: brandColors.BLACK }}>
            {' / '}
          </Box>
          <Box component="span" sx={{ color: brandColors.GREEN, fontWeight: 800 }}>
            S
          </Box>
          <Box component="span" sx={{ color: brandColors.BLACK }}>
            {' / '}
          </Box>
          <Box component="span" sx={{ color: brandColors.RED, fontWeight: 800 }}>
            R
          </Box>
        </Typography>
      </MDBox>
      <MDBox
        sx={{
          alignItems: 'center',
          backgroundColor: brandColors.GREY_LIGHT,
          border: `1px solid ${brandColors.GREY_DARK}`,
          borderRadius: '.4rem',
          display: 'flex',
          justifyContent: 'space-evenly',
          width: '7.8rem',
        }}>
        <Typography sx={{ ...valueStyle, color: brandColors.BLUE, fontWeight: 700 }}>{formatValue(justified)}</Typography>
        <Typography sx={{ ...valueStyle, color: brandColors.GREY_DARK, fontWeight: 700 }}>|</Typography>
        <Typography sx={{ ...valueStyle, color: brandColors.GREEN, fontWeight: 700 }}>{formatValue(saveable)}</Typography>
        <Typography sx={{ ...valueStyle, color: brandColors.GREY_DARK, fontWeight: 700 }}>|</Typography>
        <Typography sx={{ ...valueStyle, color: brandColors.RED, fontWeight: 700 }}>{formatValue(requested)}</Typography>
      </MDBox>
    </MDBox>
  );
};

export const CurrentData = props => {
  const hasNox = props.nox !== undefined && props.nox !== null && props.nox !== 'N/A' && props.nox > 0;
  const getValueColor = (paramType, value) => {
    if (typeof value !== 'number') {
      return 'no-color';
    }
    switch (paramType) {
      case 'nox':
        return value > 84 ? 'G' : value > 70 ? 'Y' : 'R';
      case 'Ventilation':
        return value > 84 ? 'G' : value > 70 ? 'Y' : 'R';
      case 'co2_ppm':
        return value < 800 ? 'G' : value < 1500 ? 'Y' : 'R';
      case 'cal':
        return value > 84 ? 'G' : value > 70 ? 'Y' : 'R';
      case 'pm2':
        return value < 12.25 ? 'G' : value <= 55 ? 'Y' : 'R';
      case 'pm10':
        return value < 55 ? 'G' : value <= 155 ? 'Y' : 'R';
      case 'tvoc_mass':
        return value <= 499 ? 'G' : value < 1000 ? 'Y' : 'R';
      case 'comfortLevel':
        return value > 84 ? 'G' : value > 71 ? 'Y' : 'R';
      case 'RH':
        return value > 44 && value < 61 ? 'G' : (value < 45 && value > 24) || (value > 60 && value < 71) ? 'Y' : 'R';
      default:
        return 'no-color';
    }
  };

  return (
    <Grid
      sx={{
        display: 'flex',
        flexGrow: '1',
        flexDirection: {
          xs: 'column',
        },
        marginTop: {
          xs: 0,
        },
        flexWrap: {
          xs: 'nowrap',
          sm: 'wrap',
          lg: 'nowrap',
        },
        alignItems: 'center',
        alignContent: 'center',
        // height: {
        //   xs: '42rem',
        //   sm: 'auto',
        // },
        // height: '60vh',
        justifyContent: 'flex-start',
      }}
      container>
      {/* <Draggable grid={[3, 3]} axis={'x'} bounds={'parent'}> */}
      <MDBox
        sx={{
          // backgroundColor: '#fff',
          // padding: '.5rem 2rem',
          borderRadius: '.5rem',
          width: '100%',
          height: '2rem',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          // borderTop: 'solid 2px #cdcdcd',
          // boxShadow:
          //   'inset 0px 12px 20px -10px #c1c1c1, inset 0px -10px 20px -10px #fff',
        }}>
        <LiveClock color="#3244E2"></LiveClock>
      </MDBox>
      {props.title && (
        <Typography sx={{ textAlign: 'center', fontSize: '.9rem', lineHeight: 1, marginBottom: '.40rem' }}>
          {props.title}
        </Typography>
      )}
      <MDBox
        className="currdata3container"
        sx={{
          height: '100%',
          display: 'flex',
          flexWrap: {
            xs: 'nowrap',
            sm: 'wrap',
          },
          marginTop: 0,
          flexDirection: {
            xs: 'column',
            sm: 'row',
            lg: 'column',
          },
          justifyContent: 'space-around',
          '& .MuiCard-root > .MuiBox-root': {
            height: '2.5rem',
            pb: 0.5,
          },
          '& .MuiCard-root .MuiTypography-root': {
            fontSize: '.84rem',
          },
        }}>
        <Grid item>
          <MDBox sx={MDBoxCss}>
            <BdiSummaryCard
              title="Thermal"
              justified={props.thermalJustified}
              saveable={props.thermalSaveable}
              requested={props.thermalRequested}
            />
            <BdiSummaryCard
              title="Air"
              justified={props.airJustified}
              saveable={props.airSaveable}
              requested={props.airRequested}
            />
          </MDBox>
        </Grid>
        <Grid item>
          <MDBox sx={MDBoxCss}>
            <MiniStatisticsCard
              title="Ventilation"
              value={props.co2Ratio}
              unit={typeof props.co2Ratio == 'number' ? '%' : ''}
              color={getValueColor('Ventilation', props.co2Ratio)}
              backgroundColor={brandColors.BLUE}
              borderColor={brandColors.BLUE}
              primary
            />
            <MiniStatisticsCard
              title="Co2"
              value={props.co2}
              unit={typeof props.co2Ratio == 'number' ? '(ppm)' : ''}
              color={getValueColor('co2_ppm', props.co2)}
              backgroundColor={brandColors.BLUE_LIGHT}
              labelColor={brandColors.BLACK}
              borderColor={brandColors.BLUE}
            />
            <MiniStatisticsCard
              title="Occupancy"
              value={props.occupancy}
              unit={typeof props.co2Ratio == 'number' ? '%' : ''}
              color={'no-color'}
              backgroundColor={brandColors.BLUE_LIGHT}
              labelColor={brandColors.BLACK}
              borderColor={brandColors.BLUE}
            />
          </MDBox>
        </Grid>
        <Grid item>
          <MDBox sx={MDBoxCss}>
            <MiniStatisticsCard
              color={getValueColor('cal', props.cal)}
              icon="air_purifier_gen"
              title="Clean air level"
              value={props.cal}
              backgroundColor={brandColors.GREY}
              unit={typeof props.co2Ratio == 'number' ? '%' : ''}
              borderColor={brandColors.GREY}
              primary
            />
            <MiniStatisticsCard
              color={getValueColor('pm2', props.pm2)}
              icon="blur_on"
              title="PM 2.5"
              value={props.pm2}
              backgroundColor={brandColors.GREY_LIGHT}
              unit={typeof props.co2Ratio == 'number' ? '(µg/m³)' : ''}
              labelColor={brandColors.BLACK}
              borderColor={brandColors.GREY}
            />
            <MiniStatisticsCard
              color={getValueColor('pm10', props.pm10)}
              icon="grain"
              title="PM 10"
              value={props.pm10}
              backgroundColor={brandColors.GREY_LIGHT}
              unit={typeof props.co2Ratio == 'number' ? '(µg/m³)' : ''}
              labelColor={brandColors.BLACK}
              borderColor={brandColors.GREY}
            />
            {!props.hideTvocMass && (
              <MiniStatisticsCard
                color={getValueColor('tvoc_mass', props.tvocMass)}
                icon="hive"
                title="TVOC"
                value={props.tvocMass}
                backgroundColor={brandColors.GREY_LIGHT}
                unit={typeof props.co2Ratio == 'number' ? '(µg/m³)' : ''}
                labelColor={brandColors.BLACK}
                borderColor={brandColors.GREY}
              />
            )}
          </MDBox>
          {hasNox && (
            <MiniStatisticsCard
              color={getValueColor('nox', props.nox)}
              icon="air"
              title="NOx Level"
              value={`${props.nox}%`}
              backgroundColor={brandColors.GREY_LIGHT}
              labelColor={brandColors.BLACK}
              borderColor={brandColors.GREY}
            />
          )}
        </Grid>
        <Grid item>
          <MDBox sx={MDBoxCss}>
            <MiniStatisticsCard
              mt={'3rem'}
              color={getValueColor('comfortLevel', props.comfortLevel)}
              icon="living"
              title="Comfort level"
              value={typeof props.co2Ratio == 'number' ? Math.round(props.comfortLevel) : 'N/A'}
              backgroundColor={brandColors.TURQUOISE}
              unit={typeof props.co2Ratio == 'number' ? '%' : ''}
              borderColor={brandColors.TURQUOISE}
              primary
            />
            <MiniStatisticsCard
              color={getValueColor('Temperature', props.temperature)}
              icon="thermostat"
              labelColor={brandColors.BLACK}
              title="Temperature"
              value={props.temperature}
              backgroundColor={brandColors.TURQUOISE_LIGHT}
              unit={typeof props.co2Ratio == 'number' ? '℃' : ''}
              borderColor={brandColors.TURQUOISE}
            />
            <MiniStatisticsCard
              color={getValueColor('RH', props.rh)}
              labelColor={brandColors.BLACK}
              icon="opacity"
              title="Relative Humidity"
              value={typeof props.rh == 'number' ? Math.round(props.rh) : 'N/A'}
              backgroundColor={brandColors.TURQUOISE_LIGHT}
              unit={typeof props.co2Ratio == 'number' ? '%' : ''}
              borderColor={brandColors.TURQUOISE}
            />
          </MDBox>
        </Grid>
      </MDBox>
      {/* </Draggable> */}
    </Grid>
  );
};

CurrentData.propTypes = {
  cal: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  airJustified: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  airRequested: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  airSaveable: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  co2: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  co2Ratio: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  comfortLevel: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  hideTvocMass: PropTypes.bool,
  nox: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  occupancy: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  pm2: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  pm10: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  rh: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  temperature: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  thermalJustified: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  thermalRequested: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  thermalSaveable: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.string,
  tvocMass: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
